module.exports = __webpack_public_path__ + "static/media/fruit-pear.4d47dbfe.png";